<template>

  <!-- Table Container Card -->
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
  >
    <template #create-button>
      <b-button
        v-if="$can('manage', 'All')"
        v-b-toggle.sidebar-create-period
        variant="primary"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>
    <!-- Column: Id -->
    <template #cell(index)="{ data }">
      {{ data.index + 1 }}
    </template>

    <template #cell(is_active)="{ data }">
      {{ $t(data.value ? 'Active': 'Not Active') }}
    </template>

    <template
      v-for="head in headSlotNames"
      #[head]="{ data }"
    >
      {{ $t('period.' + data.label) }}
    </template>
    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-if="$can('manage', 'All')"
          v-b-toggle.sidebar-create-letter
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'period-view', params: { id: data.item.id }})"
        />

        <feather-icon
          v-if="$can('manage', 'All')"
          v-b-toggle.sidebar-create-period
          icon="EditIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="update(data.item)"
        />
      </div>
    </template>
  </l-table>

</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import periodModule from '@/store/period/index'
import Create from './Create.vue'
import LTable from '@/views/components/LTable.vue'
import Period from '@/views/components/filters/service/Period'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    Create,
    BButton,
  },
  computed: {
    headSlotNames() {
      return this.tableColumns.map(item => `head(${item.key})`)
    },
  },
  created() {
    this.$store.commit('period/FRESH')
  },
  methods: {
    remove(data) {
      this.$removeSwal(this, data, 'period/del', this.refetchData)
    },
    update(data) {
      this.$store.commit('period/UPDATE', data)
    },
    quarterIsActive(quarters) {
      const ans = quarters.filter(quarter => quarter.is_active)
      if (ans[0]) {
        return ans[0].quarter
      }
      return 'None'
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const filterClass = new Period()
    const MODULE_NAME = 'period'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, periodModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      ...config(),
      MODULE_NAME,
      filterClass,
    }
  },
}
</script>
